import type { PublicKeyCredentialRequestOptionsJSON } from '@simplewebauthn/typescript-types';

import ACCOUNT_CLIENT_API_ENDPOINTS from '@api/endpoints';
import HTTP_METHODS_ENUM from '@api/enums/HTTP_METHODS_ENUM.enum';

import configRequest from '../configRequest';

export interface LoginWebAuthnMethodData {
	email: string;
}

export interface LoginWebAuthnMethodResponse {
	public_key: PublicKeyCredentialRequestOptionsJSON;
}

const loginWebAuthnMethod = configRequest<LoginWebAuthnMethodResponse, LoginWebAuthnMethodData>({
	requestPrefix: 'mfa/loginWebAuthnMethod',
	reqConfigCreator: data => ({
		url: ACCOUNT_CLIENT_API_ENDPOINTS.MFA.WEBAUTHN.LOGIN_REQUEST(),
		data: { user_type: 'b2c', ...data },
		method: HTTP_METHODS_ENUM.POST,
	}),
});

export default loginWebAuthnMethod;
